module.exports = __webpack_public_path__ + "media/images/blog_manager_icon-f8f169dd8f9aed66ac710591be08b480.png";